import React, { useEffect, useState } from "react";
import cx from "classnames";
import { Button } from "reactstrap";

//import TabsWidget from "../../../../components/TabsWidget/TabsWidget";
import MarketApiHelper from "../../../../weave/MarketApiHelper";
import DEFAULT_DATASET_LOGO from "../../../../assets/images/general/user-photo.svg";
import LOCAL_STORAGE from "../../../../_redux/localStorage";
import MarketHeader from "../MarketHeader/MarketHeader";

import s from "./ListingDetailsHeader.module.scss";
import InfoBubble from "../../../../components/InfoBubble/InfoBubble";
import ProductPrice from "./price/ProductPrice";

export default function ListingDetailsHeader({
	product,
	user,
	onPreview,
	goBack,
	//tabs,
}) {
	const [isSticky, setIsSticky] = useState(false);
	const stateData = LOCAL_STORAGE.loadState() || {};

	const datasetLogo = stateData.useMocks
		? product.dataset_logo
		: product.dataset_logo
		? "data:image/svg+xml;base64," + product.dataset_logo
		: DEFAULT_DATASET_LOGO;

	// ------------------------------------- METHODS -------------------------------------
	useEffect(() => {
		const handleScrollEvent = () => {
			setIsSticky(window.pageYOffset > 90);
		};

		window.addEventListener("scroll", handleScrollEvent);

		return () => {
			window.removeEventListener("scroll", handleScrollEvent);
		};
	}, []);

	return (
		<div className={cx(s.root, isSticky ? s.sticky : "")}>
			<MarketHeader hideDatasource user={user} goBack={goBack} />

			<div className={s.header}>
				{/* LEFT */}
				<div className={s.leftPanel}>
					{datasetLogo && (
						<img src={datasetLogo} alt={"logo"} className={s.logo} />
					)}

					<div className={s.powered}>
						<div className={s.label}>Provided by:</div>
						<div className={s.author}>{product.author}</div>
					</div>
				</div>

				{/* TITLE */}
				<div className={s.titleContainer}>
					<p className={s.title}>{product.title}</p>
					<p className={s.description}>{product.description}</p>

					<div className={s.powered}>
						<span className={s.label}>Provided by:</span>
						<span className={s.author}>{product.author}</span>
					</div>
				</div>

				{/* BUTTONS */}
				<div className={s.buttonsPanel}>
					{product.price && (
						<div className={s.price}>
							<div className={s.priceLabel}>
								<span>Estimated Total Price</span> <InfoBubble />
							</div>

							<ProductPrice product={product} className={s.priceValue} />
						</div>
					)}

					{onPreview && (
						<div className={s.previewButton} onClick={onPreview}>
							<Button className={cx(s.button, "btn-border")} color="primary">
								Preview
							</Button>
						</div>
					)}

					<Button
						className={cx(s.button, "btn-default")}
						color="primary"
						onClick={() =>
							product.price < 0
								? MarketApiHelper.downloadPrePaid(product)
								: MarketApiHelper.downloadPaid(product)
						}
					>
						Download
					</Button>
				</div>
			</div>

			{/* <TabsWidget tabs={tabs} className={s.tabs} /> */}
		</div>
	);
}
